var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoreicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1667 3.33325H3.83333V4.99992H17.1667V3.33325ZM18 11.6666V9.99992L17.1667 5.83325H3.83333L3 9.99992V11.6666H3.83333V16.6666H12.1667V11.6666H15.5V16.6666H17.1667V11.6666H18ZM10.5 14.9999H5.5V11.6666H10.5V14.9999Z",
    fill: "#EEC044"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreicon);
export default __webpack_public_path__ + "static/media/storeicon.2e7e20aebee359aee797263bea6c4a05.svg";
export { ForwardRef as ReactComponent };